import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, UntypedFormArray } from '@angular/forms';
import { LoadingService } from '../../services/loading/loading.service';
import { requestedTotalValuationValidator } from './validators';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HhgShipmentAccessorialAdditionalinfoComponent } from '../hhg-shipment-accessorial-additionalinfo/hhg-shipment-accessorial-additionalinfo.component';
import { HhgExtraPickupdeliveryAddressComponent } from '../hhg-extra-pickupdelivery-address/hhg-extra-pickupdelivery-address.component';
import { HhgAccessorialsService } from '../../services/hhg-accessorials/hhg-accessorials.service';
import { HhgBookShipAccessorialsService } from '../../services/hhg-book-ship-accessorials/hhg-book-ship-accessorials.service';
import { HhgBookShipAccessorials } from '../hhg-shipment-accessorials/hhg-shipment-accessorial';
import { AlertService } from 'src/app/services/alert/alert.service';
import { HhgShipmentAccessorialAdditionalInfoService } from 'src/app/services/hhg-shipment-accessorial-additionalinfo/hhg-book-ship-accessorials-additionalinfo.service';
import { Location } from '@angular/common';
import { AuditTrail } from './audit-trail';
import { HhgShipmentAuditTrailService } from 'src/app/services/hhg-shipment-audit-trail/hhg-shipment-audit-trail.service';
import AppConstants, { NameAndAddressRecordType } from 'src/app/shared/common-components/AppConstants';
import { BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs';
import { UserService } from '../../services/user/user.service';
import { HhgOnlineBookShipmentService } from '../hhg-online-book-shipment/hhg-online-book-shipment.service';
import { HhgQueryRequest } from 'src/app/shared/common-components/common-structure';

@Component({
    selector: 'app-hhg-shipment-accessorials',
    templateUrl: './hhg-shipment-accessorials.component.html',
    styleUrls: ['./hhg-shipment-accessorials.component.css'],
    standalone: false
})
export class HhgShipmentAccessorialsComponent implements OnInit, OnDestroy {

  @Input() routedFrom: any;
  @Input() shipmentInfoIdFromUrl: number;
  private observer$ = new BehaviorSubject(true);
  isCarrierView = false; // use this field and set it to true if its carrier view
  hhgShipmentAccessorialForm: UntypedFormGroup;
  validationMessages: any;
  accessorialArray = [];
  storageTransitDisplay = false;
  excessValuationDisplay = false;
  exclusiveUseOfVehiclesDisplay = false;
  expeditedServiceDisplay = false;
  travelTimeDisplay = false;
  debrisRemovalDisplay = false;
  extraLaborDisplay = false;
  shuttleServiceDisplay = false;
  bulkyArticlesDisplay = false;
  exportImportChargeDisplay = false;
  pickupDeliveryHolDisplay = false;
  carrierSuperPersonnelDisplay = false;
  warehousePickUpDeliveryHolDisplay = false;
  otherHhgAccServicesDisplay = false;
  extraPickUpDeliveryDisplay = false;
  isIntOrigin = true;
  isIntDest = true;
  bsModalRef: BsModalRef;
  sitTypes: any;
  excessValuation: any;
  accessorialList: any;
  accessorialDesc: any;
  shipmentsId: any;
  bookShipmentId: number;
  redirectedFromBol: boolean;
  existingAccessorials: any;
  hhg: any;
  hhg2: any;
  hhgBookShipAccessorials: HhgBookShipAccessorials;
  bookShipArray = [];
  retrieveSuccess: any;
  saveSuccess: any;
  currentExisting: any;
  messageArray = [];
  existingMessages = [];
  zeroAccessorialCount: boolean;
  savedOriginCost = 0;
  savedDestCost = 0;
  releasedValuationWeight = 0;
  excessCostValTransport = 0;
  excessCostValStorage = 0;
  totalCostExcessValuation = 0;

  shipperAuthorization: String[] = [
    'Authorized',
    'Pending',
    'Cancelled',
    'Rejected'
  ];

  tspAuthorization: String[] = [
    'Accepted',
    /*'Issued',
    'Pending',*/
    'Qualified'
  ];

  sitTypesRef: any[] = [
    { name: 'Origin', value: 'Origin' },
    { name: 'Destination', value: 'Destination' }
  ];

  noDaysList: number[] = [
    30,
    60,
    90
  ];

  accessorialInfo: any = {
    // readonly info
    drnSuffix: '',
    billLading: '',
    releasedValuationCost: '',
    excessCostValTransport: '',
    excessCostValStorage: '',
    totalCostExcessValuation: '',
    excessValTspAcceptance: '',
    originCountry: '',
    originCity: '',
    originState: '',
    originWeight: '',
    originStorageCost: '',
    originsitMilesCost: '',
    originIntSitCost: '',
    originTspAcceptance: '',
    destCity: '',
    destState: '',
    destWeight: '',
    destCountry: '',
    destStorageCost: '',
    destsitMilesCost: '',
    destIntSitCost: '',
    destTspAcceptance: '',
    totalSitCharge: '',
    eovTspAcceptance: '',
    exServTspAcceptance: '',
    ttTspAcceptance: '',
    drTspAcceptance: '',
    extLaborTspAcceptance: '',
    sServiceTspAcceptance: '',
    baTspAcceptance: '',
    edChargeTspAcceptance: '',
    pdHolTspAcceptance: '',
    csPersonnelTspAcceptance: '',
    whPickDelTspAcceptance: '',
    otherHhgAccSerTspAcceptance: '',
    extraPickDelTspAcceptance: ''
  };
  currentMessage: any;
  additionalMessageResponse: any;
  shipmentDetailsData: any;
  auditTrailArray: any[];
  adt: any;
  existingAuditTrail: any;
  hhgStorageCalculatedResults: any;

  constructor(private formBuilder: UntypedFormBuilder, private loader: LoadingService, private modalService: BsModalService, private router: Router,
    private hhgAccessorialsService: HhgAccessorialsService, private route: ActivatedRoute,
    private userService: UserService,
    private hhgBookShipAccessorialsService: HhgBookShipAccessorialsService, private alertService: AlertService,
    private hhgShipmentAccessorialAdditionalInfoService: HhgShipmentAccessorialAdditionalInfoService,
    private location: Location, private shipmentAuditTrailService: HhgShipmentAuditTrailService,
    private bookShipmentService: HhgOnlineBookShipmentService
  ) {
    this.createHHGShipmentAccessorialForm();
    this.validationMessages = {
      'accessorialAvailableList': [
        { type: 'required', message: 'Atleast one Accessorial Code is required to validate' }
      ],
      'reqTotalValuation': [
        { type: 'required', message: 'Requested total valuation cost is required' },
        { type: 'notAcceptable', message: 'Requested total valuation cost cannot be lower than the total cost of excess valuation' }
      ],
      'originNoDays': [
        { type: 'required', message: 'No. of days is required to validate' }
      ],
      'originIntNoDays': [
        { type: 'required', message: 'No. of days is required to validate' }
      ],
      'destNoDays': [
        { type: 'required', message: 'No. of days is required to validate' }
      ],
      'destIntNoDays': [
        { type: 'required', message: 'AtleaNo. of days is required to validate' }
      ],
    };

  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.route.queryParams.subscribe(params => {
      this.shipmentsId = params['shipmentid'];
      this.bookShipmentId = params['bookshipmentid'];
    });
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
        this.loadCarrierView(currentUser);
      }, (error) => {
        this.loader.hide();
      });
    if (this.routedFrom === 'bol') {
      this.redirectedFromBol = true;
      this.shipmentsId = this.shipmentInfoIdFromUrl;
      this.hhgShipmentAccessorialForm.get('excessValuation').get('excessValuationShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('excessValuation').get('excessValuationTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('originShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('destShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('originNoDays').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('originIntNoDays').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('destNoDays').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('destIntNoDays').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('originCb').disable();
      this.hhgShipmentAccessorialForm.get('storageInTransit').get('destCb').disable();
      this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles').get('eovShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles').get('eovTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('expeditedService').get('exServShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('expeditedService').get('exServTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('travelTime').get('ttShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('travelTime').get('ttTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('debrisRemoval').get('drShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('debrisRemoval').get('drTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('extraLabor').get('extLaborShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('extraLabor').get('extLaborTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('shuttleService').get('sServiceShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('shuttleService').get('sServiceTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('bulkyArticles').get('baShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('bulkyArticles').get('baTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('exportImportCharge').get('eiChargeShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('exportImportCharge').get('eiChargeTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('pickupDeliveryHol').get('pdHolShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('pickupDeliveryHol').get('pdHolTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel').get('csPersonnelShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel').get('csPersonnelTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery').get('whPickDelShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery').get('whPickDelTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('otherHhgAccServices').get('otherHhgAccSerShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('otherHhgAccServices').get('otherHhgAccSerTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('extraPickUpDelivery').get('extraPickDelShipAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('extraPickUpDelivery').get('extraPickDelTspAuthorize').disable();
      this.hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').disable();
    } else {
      this.redirectedFromBol = false;
    }
    this.loader.show();
    if (this.shipmentsId !== undefined) {
    this.hhgBookShipAccessorialsService.getAccessorialsByShipmentId(this.shipmentsId).subscribe(existing => {
      if (existing != null) {
        this.zeroAccessorialCount = false;
        this.existingAccessorials = existing;
        this.loadExistingData();
      } else {
        this.zeroAccessorialCount = true;
      }
    }, (error) => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving the accessorials');
      this.retrieveSuccess = false;
    }, () => {
      this.retrieveSuccess = true;
    });
  }
    this.hhgAccessorialsService.getAll().subscribe(accessorials => {
      this.accessorialList = accessorials;
    }, (error) => {
      this.alertService.error('Error while getting accessorials');
    });
  if (this.bookShipmentId !== undefined) {
    this.bookShipmentService.getShipmentInfoByBookShipmentId(this.bookShipmentId).
      subscribe(data => {
        this.shipmentDetailsData = data;
        if (this.storageTransitDisplay && this.routedFrom !== 'bol') {
          this.getStorageCalculatedResults();
        } else {
          this.handleExcessVal();
          this.handleStorageAtOrigin();
          this.handleStorageAtDestination();
        }
        this.loader.hide();
        // this.handleValuation();
      }, error => {
        this.loader.hide();
      });
    }
    /*
        If we know the user is shipper , user can add accessorials
        //If the user is  carrier we add form groups & assign values as well. Do we need to disable the drop down for accessorial available list
        */
    if (this.shipmentsId !== undefined) {
        this.shipmentAuditTrailService.getAuditTrailListByShipmentId(this.shipmentsId)
          .subscribe(data => {
            if (data) {
              this.existingAuditTrail = data;
            }
          }, (error) => {
          });
    }
  }

  loadCarrierView(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser)) {
      const carrierRoles = AppConstants.getCarrierRolesArray();
      if (currentUser.roles.some(role => carrierRoles.indexOf(role.name) >= 0)) {
        this.isCarrierView = true;
      }
    }
  }
  clearAllOrigin() {
    if (AppConstants.isNotNullCondition(this.accessorialInfo.totalSitCharge) && AppConstants.isNotNullCondition(this.accessorialInfo.originStorageCost)
    && AppConstants.isNotNullCondition(this.accessorialInfo.originsitMilesCost)) {
      this.accessorialInfo.totalSitCharge = (this.accessorialInfo.totalSitCharge - this.accessorialInfo.originsitMilesCost - this.accessorialInfo.originStorageCost).toFixed(2);
    }
    this.accessorialInfo.originsitMilesCost = 0;
    this.accessorialInfo.originStorageCost = 0;

    this.hhgShipmentAccessorialForm.get('storageInTransit.originShipAuthorize').setValue('Authorized');
    this.hhgShipmentAccessorialForm.get('storageInTransit.originNoDays').setValue(null);
    this.hhgShipmentAccessorialForm.get('storageInTransit.originTspAuthorize').setValue(null);
  }
  clearAllDest() {
    if (AppConstants.isNotNullCondition(this.accessorialInfo.totalSitCharge) && AppConstants.isNotNullCondition(this.accessorialInfo.destsitMilesCost) && AppConstants.isNotNullCondition(this.accessorialInfo.destStorageCost)) {
      this.accessorialInfo.totalSitCharge = (this.accessorialInfo.totalSitCharge - this.accessorialInfo.destsitMilesCost - this.accessorialInfo.destStorageCost).toFixed(2);
    }
    this.accessorialInfo.destsitMilesCost = 0;
    this.accessorialInfo.destStorageCost = 0;
    this.hhgShipmentAccessorialForm.get('storageInTransit.destShipAuthorize').setValue('Authorized');
    this.hhgShipmentAccessorialForm.get('storageInTransit.destNoDays').setValue(null);
    this.hhgShipmentAccessorialForm.get('storageInTransit.destTspAuthorize').setValue(null);
      }
  handleExcessVal() {
      const hhgCostInfo = this.shipmentDetailsData.hhgShipmentsCostInfoEntity;
      const sroId = this.shipmentDetailsData.ratesSroMasterEntity.sroId;
      this.releasedValuationWeight = this.shipmentDetailsData.weight;
      if (sroId === 'USPDC') {
        this.accessorialInfo.releasedValuationCost = this.releasedValuationWeight * 10.00;
      } else if (sroId === 'DVADC') {
        this.accessorialInfo.releasedValuationCost = this.releasedValuationWeight * 7.00;
      } else if (sroId === 'NBCC0' || sroId === 'GEOVA' || sroId === 'FSVNM' || sroId === 'CONDI' || sroId === 'DOSDD') {
        this.accessorialInfo.releasedValuationCost = this.releasedValuationWeight * 6.50;
      } else if (sroId === 'DOSDC') {
        this.accessorialInfo.releasedValuationCost = this.releasedValuationWeight * 8.50;
      } else {
        this.accessorialInfo.releasedValuationCost = this.releasedValuationWeight * 6.00;
      }
  }

    handleStorageAtOrigin() {
    const existingOriginDays = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originNoDays'];
    if (AppConstants.isNotNullCondition(existingOriginDays)) {
      this.setOriginCalculatedResults(existingOriginDays);
    }
    this.hhgShipmentAccessorialForm.get('storageInTransit.originNoDays').valueChanges.subscribe(days => {
      if (AppConstants.isNotNullCondition(days) && days !== 'null') {
        this.setOriginCalculatedResults(days);
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('originShipAuthorize').setValue('Authorized');
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('originTspAuthorize').setValue(null);
      } else if (days === 'null') {
        this.clearAllOrigin();
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('originShipAuthorize').setValue('');
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('originTspAuthorize').setValue(null);
      }
    });
  }

  setOriginCalculatedResults(days) {
    if (days === 30) {
      this.accessorialInfo.originStorageCost = this.hhgStorageCalculatedResults.originThirtyDayCharge;
    } else if (days === 60) {
      this.accessorialInfo.originStorageCost = this.hhgStorageCalculatedResults.originSixtyDayCharge;
    } else if (days === 90) {
      this.accessorialInfo.originStorageCost = this.hhgStorageCalculatedResults.originNinetyDayCharge;
    }
    this.accessorialInfo.originsitMilesCost = this.hhgStorageCalculatedResults.originDeliveryCharge;
    const destinationStorageCost = AppConstants.isNotNullCondition(this.accessorialInfo.destStorageCost) ? parseFloat(this.accessorialInfo.destStorageCost) : 0;
    const destinationSitMilesCost = AppConstants.isNotNullCondition(this.accessorialInfo.destsitMilesCost) ? parseFloat(this.accessorialInfo.destsitMilesCost) : 0;
    const originStorageCostValue = AppConstants.isNotNullCondition(this.accessorialInfo.originStorageCost) ? parseFloat(this.accessorialInfo.originStorageCost) : 0;
    const originSitMilesCost = AppConstants.isNotNullCondition(this.accessorialInfo.originsitMilesCost) ? parseFloat(this.accessorialInfo.originsitMilesCost) : 0;
    if (!AppConstants.isNotNullCondition(this.accessorialInfo.originStorageCost) && AppConstants.isNotNullCondition(this.accessorialInfo.destStorageCost)) {
      this.accessorialInfo.totalSitCharge = (destinationStorageCost + destinationSitMilesCost).toFixed(2);
    } else if (AppConstants.isNotNullCondition(this.accessorialInfo.originStorageCost) && !AppConstants.isNotNullCondition(this.accessorialInfo.destStorageCost)) {
      this.accessorialInfo.totalSitCharge = (originStorageCostValue + originSitMilesCost).toFixed(2);
    } else {
      this.accessorialInfo.totalSitCharge = (destinationStorageCost + destinationSitMilesCost + originStorageCostValue + originSitMilesCost).toFixed(2);
    }
  }

  setDestinationCalculatedResults(days) {
    if (days === 30) {
      this.accessorialInfo.destStorageCost = this.hhgStorageCalculatedResults.destThirtyDayCharge;
    } else if (days === 60) {
      this.accessorialInfo.destStorageCost = this.hhgStorageCalculatedResults.destSixtyDayCharge;
    } else if (days === 90) {
      this.accessorialInfo.destStorageCost = this.hhgStorageCalculatedResults.destNinetyDayCharge;
    }
    this.accessorialInfo.destsitMilesCost = this.hhgStorageCalculatedResults.destDeliveryCharge;
    const destinationStorageCost = AppConstants.isNotNullCondition(this.accessorialInfo.destStorageCost) ? parseFloat(this.accessorialInfo.destStorageCost) : 0;
    const destinationSitMilesCost = AppConstants.isNotNullCondition(this.accessorialInfo.destsitMilesCost) ? parseFloat(this.accessorialInfo.destsitMilesCost) : 0;
    const originStorageCostValue = AppConstants.isNotNullCondition(this.accessorialInfo.originStorageCost) ? parseFloat(this.accessorialInfo.originStorageCost) : 0;
    const originSitMilesCost = AppConstants.isNotNullCondition(this.accessorialInfo.originsitMilesCost) ? parseFloat(this.accessorialInfo.originsitMilesCost) : 0;
    if (!AppConstants.isNotNullCondition(this.accessorialInfo.destStorageCost)) {
      this.accessorialInfo.totalSitCharge = 0;
    } else if (!AppConstants.isNotNullCondition(this.accessorialInfo.originStorageCost)) {
      this.accessorialInfo.totalSitCharge = (destinationStorageCost + destinationSitMilesCost).toFixed(2);
    } else {
      this.accessorialInfo.totalSitCharge = (destinationStorageCost + destinationSitMilesCost + originStorageCostValue + originSitMilesCost).toFixed(2);
    }
  }

  handleStorageAtDestination() {
    const existingDestinationDays = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destNoDays'];
    if (AppConstants.isNotNullCondition(existingDestinationDays)) {
      this.setDestinationCalculatedResults(existingDestinationDays);
    }
    this.hhgShipmentAccessorialForm.get('storageInTransit.destNoDays').valueChanges.subscribe(days => {
      if (AppConstants.isNotNullCondition(days) && days !== 'null') {
        this.setDestinationCalculatedResults(days);
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('destShipAuthorize').setValue('Authorized');
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('destTspAuthorize').setValue(null);
      } else if (days === 'null') {
        this.clearAllDest();
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('destShipAuthorize').setValue('');
        this.hhgShipmentAccessorialForm.get('storageInTransit').get('destTspAuthorize').setValue(null);
      }
    });
  }

  createHHGShipmentAccessorialForm() {
    this.hhgShipmentAccessorialForm = this.formBuilder.group({
      accessorialAvailableList: new UntypedFormControl('', Validators.required),
      excessValuation: new UntypedFormGroup({
        reqTotalValuation: new UntypedFormControl(''),
        excessValuationShipAuthorize: new UntypedFormControl(''),
        excessValuationTspAuthorize: new UntypedFormControl('')
      }),
      storageInTransit: new UntypedFormGroup({
        originCb: new UntypedFormControl(false),
        originShipAuthorize: new UntypedFormControl(''),
        originNoDays: new UntypedFormControl(''),
        originIntNoDays: new UntypedFormControl(''),
        destCb: new UntypedFormControl(false),
        destShipAuthorize: new UntypedFormControl(''),
        destNoDays: new UntypedFormControl(''),
        destIntNoDays: new UntypedFormControl(''),
        originTspAuthorize: new UntypedFormControl(''),
        destTspAuthorize: new UntypedFormControl('')
      }),
      exclusiveUseOfVehicles: new UntypedFormGroup({
        eovShipAuthorize: new UntypedFormControl(),
        eovTspAuthorize: new UntypedFormControl(),
      }),
      expeditedService: new UntypedFormGroup({
        exServShipAuthorize: new UntypedFormControl(''),
        exServTspAuthorize: new UntypedFormControl(''),
      }),
      travelTime: new UntypedFormGroup({
        ttShipAuthorize: new UntypedFormControl(''),
        ttTspAuthorize: new UntypedFormControl(''),
      }),
      debrisRemoval: new UntypedFormGroup({
        drShipAuthorize: new UntypedFormControl(''),
        drTspAuthorize: new UntypedFormControl(''),
      }),
      extraLabor: new UntypedFormGroup({
        extLaborShipAuthorize: new UntypedFormControl(''),
        extLaborTspAuthorize: new UntypedFormControl(''),
      }),
      shuttleService: new UntypedFormGroup({
        sServiceShipAuthorize: new UntypedFormControl(''),
        sServiceTspAuthorize: new UntypedFormControl(''),
      }),
      bulkyArticles: new UntypedFormGroup({
        baShipAuthorize: new UntypedFormControl(''),
        baTspAuthorize: new UntypedFormControl(''),
      }),
      exportImportCharge: new UntypedFormGroup({
        eiChargeShipAuthorize: new UntypedFormControl(''),
        eiChargeTspAuthorize: new UntypedFormControl(''),
      }),
      pickupDeliveryHol: new UntypedFormGroup({
        pdHolShipAuthorize: new UntypedFormControl(''),
        pdHolTspAuthorize: new UntypedFormControl(''),
      }),
      carrierSuperPersonnel: new UntypedFormGroup({
        csPersonnelShipAuthorize: new UntypedFormControl(''),
        csPersonnelTspAuthorize: new UntypedFormControl(''),
      }),
      warehousePickUpDelivery: new UntypedFormGroup({
        whPickDelShipAuthorize: new UntypedFormControl(''),
        whPickDelTspAuthorize: new UntypedFormControl(''),
      }),
      otherHhgAccServices: new UntypedFormGroup({
        otherHhgAccSerShipAuthorize: new UntypedFormControl(''),
        otherHhgAccSerTspAuthorize: new UntypedFormControl(''),
      }),
      extraPickUpDelivery: new UntypedFormGroup({
        extraPickDelShipAuthorize: new UntypedFormControl(''),
        extraPickDelTspAuthorize: new UntypedFormControl(''),
      })
    });
  }

  createSitForm() {
    return this.formBuilder.group({
      originCb: new UntypedFormControl(false),
      originShipAuthorize: new UntypedFormControl(''),
      originNoDays: new UntypedFormControl(''),
      originIntNoDays: new UntypedFormControl(''),
      destCb: new UntypedFormControl(false),
      destShipAuthorize: new UntypedFormControl(''),
      destNoDays: new UntypedFormControl(''),
      destIntNoDays: new UntypedFormControl('')
    });
  }

  createSitTypesControls() {
    const sitArray = this.sitTypesRef.map(sType => {
      return new UntypedFormControl(
        this.sitTypes.find(sTypeVal => sTypeVal === sType.value));

    });
    return new UntypedFormArray(sitArray);
  }

  getStorageCalculatedResults() {
    const inputPayload = new HhgQueryRequest();
    inputPayload.pickupDate = this.shipmentDetailsData.moveDate ;
    inputPayload.estimatedWeight = this.shipmentDetailsData.weight;
    inputPayload.rateId = this.shipmentDetailsData.hhgShipmentsCostInfoEntity != null ?
      this.shipmentDetailsData.hhgShipmentsCostInfoEntity.rateId : null;
    inputPayload.shipmentType = 'Domestic';
    const ratesSroInfo = this.shipmentDetailsData.ratesSroMasterEntity;

    const addressInfo = this.shipmentDetailsData.nameAndAddressEntity;
    let originCountry = '', destinationCountry = '';
    addressInfo.forEach(addressObj => {
      const country = addressObj.countryEntity.stateCountryName;
      const stateCountryCode2Digit = AppConstants.isNotNullCondition(addressObj.stateEntity) ?
          addressObj.stateEntity.stateCountryCode2Digit : addressObj.stateEntity;
      const stateCountryId = AppConstants.isNotNullCondition(addressObj.stateEntity) ?
          addressObj.stateEntity.stateCountryId : addressObj.stateEntity;
      if (addressObj.recordType === NameAndAddressRecordType.ORIGIN) {
        inputPayload.originZip = addressObj.zipCode;
        inputPayload.originStateAbbr = stateCountryCode2Digit;
        inputPayload.originId = stateCountryId;
        originCountry = country;
        if (originCountry !== 'UNITED STATES') {
          const countryId = AppConstants.isNotNullCondition(addressObj.countryEntity) ?
          addressObj.countryEntity.stateCountryId : addressObj.countryEntity;
          inputPayload.originId = countryId;
        }
      } else if (addressObj.recordType === NameAndAddressRecordType.DESTINATION) {
        inputPayload.destZip = addressObj.zipCode;
        inputPayload.destStateAbbr = stateCountryCode2Digit;
        inputPayload.destinationId = stateCountryId;
        destinationCountry = country;
        if (destinationCountry !== 'UNITED STATES') {
          const countryId = AppConstants.isNotNullCondition(addressObj.countryEntity) ?
          addressObj.countryEntity.stateCountryId : addressObj.countryEntity;
          inputPayload.destinationId = countryId;
        }
      }
    });
    if (originCountry && destinationCountry && (originCountry !== 'UNITED STATES' || destinationCountry !== 'UNITED STATES')) {
      inputPayload.shipmentType = 'International';
    }
    this.loader.show();
      this.hhgBookShipAccessorialsService.getHhgCalculatedResults(inputPayload).pipe(takeWhile(() => this.observer$.value))
      .subscribe(results => {
        this.hhgStorageCalculatedResults = results;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('Error while getting hhg calculated results. Please contact system administrator.');
      }, () => {

        this.handleExcessVal();
        this.handleStorageAtOrigin();
        this.handleStorageAtDestination();
      });
    // }
  }

  /**
   * @description To show the corresponding form group from the list
   * @param eventObj
   */
  addAccessorialList(eventObj) {
    if ((eventObj.target.value.indexOf('Storage') !== -1 || eventObj.target.value.indexOf('P/D') !== -1) && !this.storageTransitDisplay) {
      this.storageTransitDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'storageInTransit';
      accObj['saCtl'] = 'originShipAuthorize';
      accObj['tspStl'] = 'originTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setTspAcceptance('storageInTransit', 'originTspAuthorize');
      this.getStorageCalculatedResults();
    } else if ((eventObj.target.value.indexOf('Cost of Extra') !== -1 || eventObj.target.value.indexOf('Cost of Excess')) !== -1 && !this.excessValuationDisplay) {
      this.excessValuationDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'excessValuation';
      accObj['saCtl'] = 'excessValuationShipAuthorize';
      accObj['tspStl'] = 'excessValTspAcceptance';
      this.accessorialArray.push(accObj);

      const excessValFg = this.hhgShipmentAccessorialForm.get('excessValuation') as UntypedFormGroup;
      excessValFg.get('reqTotalValuation').setValidators([Validators.required, requestedTotalValuationValidator(this.accessorialInfo.releasedValuationCost)]);
    } else if (eventObj.target.value.indexOf('Exclusive Use of Vehicles') !== -1 && !this.exclusiveUseOfVehiclesDisplay) {
      this.exclusiveUseOfVehiclesDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'exclusiveUseOfVehicles';
      accObj['saCtl'] = 'eovShipAuthorize';
      accObj['tspStl'] = 'eovTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('exclusiveUseOfVehicles', 'eovShipAuthorize', 'eovTspAuthorize');
    } else if (eventObj.target.value.indexOf('Expedited Service') !== -1 && !this.expeditedServiceDisplay) {
      this.expeditedServiceDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'expeditedService';
      accObj['saCtl'] = 'exServShipAuthorize';
      accObj['tspStl'] = 'exServTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('expeditedService', 'exServShipAuthorize', 'exServTspAuthorize');
      // this.setTspAcceptance('exServTspAcceptance');
    } else if (eventObj.target.value.indexOf('Travel Time - Extra Driver') !== -1 && !this.travelTimeDisplay) {
      this.travelTimeDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'travelTime';
      accObj['saCtl'] = 'ttShipAuthorize';
      accObj['tspStl'] = 'ttTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('travelTime', 'ttShipAuthorize', 'ttTspAuthorize');
    } else if (eventObj.target.value.indexOf('Debris Removal') !== -1 && !this.debrisRemovalDisplay) {
      this.debrisRemovalDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'debrisRemoval';
      accObj['saCtl'] = 'drShipAuthorize';
      accObj['tspStl'] = 'drTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('debrisRemoval', 'drShipAuthorize', 'drTspAuthorize');
    } else if (eventObj.target.value.indexOf('Extra Labor') !== -1 && !this.extraLaborDisplay) {
      this.extraLaborDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'extraLabor';
      accObj['saCtl'] = 'extLaborShipAuthorize';
      accObj['tspStl'] = 'extLaborTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('extraLabor', 'extLaborShipAuthorize', 'extLaborTspAuthorize');
    } else if (eventObj.target.value.indexOf('Shuttle Service') !== -1 && !this.shuttleServiceDisplay) {
      this.shuttleServiceDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'shuttleService';
      accObj['saCtl'] = 'sServiceShipAuthorize';
      accObj['tspStl'] = 'sServiceTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('shuttleService', 'sServiceShipAuthorize', 'sServiceTspAuthorize');
    } else if (eventObj.target.value.indexOf('Bulky Articles') !== -1 && !this.bulkyArticlesDisplay) {
      this.bulkyArticlesDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'bulkyArticles';
      accObj['saCtl'] = 'baShipAuthorize';
      accObj['tspStl'] = 'baTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('bulkyArticles', 'baShipAuthorize', 'baTspAuthorize');
    } else if (eventObj.target.value.indexOf('Export or Import Charge') !== -1 && !this.exportImportChargeDisplay) {
      this.exportImportChargeDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'exportImportCharge';
      accObj['saCtl'] = 'eiChargeShipAuthorize';
      accObj['tspStl'] = 'eiChargeTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('exportImportCharge', 'eiChargeShipAuthorize', 'eiChargeTspAuthorize');
    } else if (eventObj.target.value.indexOf('Saturday') !== -1 && !this.pickupDeliveryHolDisplay) {
      this.pickupDeliveryHolDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'pickupDeliveryHol';
      accObj['saCtl'] = 'pdHolShipAuthorize';
      accObj['tspStl'] = 'pdHolTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('pickupDeliveryHol', 'pdHolShipAuthorize', 'pdHolTspAuthorize');
    } else if (eventObj.target.value.indexOf('Carrier Supervisory Personnel') !== -1 && !this.carrierSuperPersonnelDisplay) {
      this.carrierSuperPersonnelDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'carrierSuperPersonnel';
      accObj['saCtl'] = 'csPersonnelShipAuthorize';
      accObj['tspStl'] = 'csPersonnelTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('carrierSuperPersonnel', 'csPersonnelShipAuthorize', 'csPersonnelTspAuthorize');
    } else if (eventObj.target.value.indexOf('Warehouse Pickup/Delivery') !== -1 && !this.warehousePickUpDeliveryHolDisplay) {
      this.warehousePickUpDeliveryHolDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'warehousePickUpDelivery';
      accObj['saCtl'] = 'whPickDelShipAuthorize';
      accObj['tspStl'] = 'whPickDelTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('warehousePickUpDelivery', 'whPickDelShipAuthorize', 'whPickDelTspAuthorize');
    } else if (eventObj.target.value.indexOf('Other HHG') !== -1 && !this.otherHhgAccServicesDisplay) {
      this.otherHhgAccServicesDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'otherHhgAccServices';
      accObj['saCtl'] = 'otherHhgAccSerShipAuthorize';
      accObj['tspStl'] = 'otherHhgAccSerTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('otherHhgAccServices', 'otherHhgAccSerShipAuthorize', 'otherHhgAccSerTspAuthorize');
    } else if (eventObj.target.value.indexOf('Extra Pickup/Delivery Address') !== -1 && !this.extraPickUpDeliveryDisplay) {
      this.extraPickUpDeliveryDisplay = true;
      const accObj = {};
      accObj['controlName'] = 'extraPickUpDelivery';
      accObj['saCtl'] = 'extraPickDelShipAuthorize';
      accObj['tspStl'] = 'extraPickDelTspAcceptance';
      this.accessorialArray.push(accObj);
      this.setShipAuth('extraPickUpDelivery', 'extraPickDelShipAuthorize', 'extraPickDelTspAuthorize');

      this.openExtraPickupDeliveryAddress();
    }
  }

  /**
   * @description iterates the form controls in a form group to empty string
   */
  setFormValueToNull(form) {
    Object.keys(form.controls).forEach(key => {
      form.get(key).setValue('');
    });
  }

  /**
   * @description To remove one of the selected accessorial codes
   * @param type
   */
  deleteAccessorialCode(type) {
    this.hhgShipmentAccessorialForm.get('accessorialAvailableList').setValue('');

    if (type.trim().indexOf('Excess Valuation') !== -1) {
      const excessValFg = this.hhgShipmentAccessorialForm.get('excessValuation') as UntypedFormGroup;
      excessValFg.get('reqTotalValuation').clearValidators();
      this.excessValuationDisplay = false;
      this.processAccArray('excessValuation');
      this.deleteExistingData(47);
      this.deleteExistingData(48);
      this.setFormValueToNull(this.hhgShipmentAccessorialForm.get('excessValuation'));
      this.totalCostExcessValuation = 0;
      this.excessCostValTransport = 0;
      this.excessCostValStorage = 0;
    } else if (type.trim().indexOf('Storage In Transit') !== -1) {
      const sitOriginFg = this.hhgShipmentAccessorialForm.get('storageInTransit') as UntypedFormGroup;
      sitOriginFg.get('originNoDays').clearValidators();
      sitOriginFg.get('originIntNoDays').clearValidators();

      sitOriginFg.get('destNoDays').clearValidators();
      sitOriginFg.get('destIntNoDays').clearValidators();
      this.storageTransitDisplay = false;
      this.processAccArray('StorageTransit');
      this.deleteExistingData(46);
      this.deleteExistingData(49);
      this.setFormValueToNull(this.hhgShipmentAccessorialForm.get('storageInTransit'));
      this.accessorialInfo.originStorageCost = '';
      this.accessorialInfo.originsitMilesCost = '';
      this.accessorialInfo.destStorageCost = '';
      this.accessorialInfo.destsitMilesCost = '';
      this.excessCostValStorage = 0;
      this.totalCostExcessValuation = this.excessCostValTransport + this.excessCostValStorage;
    } else if (type.trim().indexOf('Exclusive Vehicle Use') !== -1) {
      this.exclusiveUseOfVehiclesDisplay = false;
      this.processAccArray('exclusiveUseOfVehicles');
      this.deleteExistingData(36);
    } else if (type.trim().indexOf('Expedited Service') !== -1) {
      this.expeditedServiceDisplay = false;
      this.processAccArray('expeditedService');
      this.deleteExistingData(37);
    } else if (type.trim().indexOf('Travel Time') !== -1) {
      this.travelTimeDisplay = false;
      this.processAccArray('travelTime');
      this.deleteExistingData(39);
    } else if (type.trim().indexOf('Extra Labor') !== -1) {
      this.extraLaborDisplay = false;
      this.processAccArray('extraLabor');
      this.deleteExistingData(41);
    } else if (type.trim().indexOf('Debris Removal') !== -1) {
      this.debrisRemovalDisplay = false;
      this.processAccArray('debrisRemoval');
      this.deleteExistingData(40);
    } else if (type.trim().indexOf('Shuttle Service') !== -1) {
      this.shuttleServiceDisplay = false;
      this.processAccArray('shuttleService');
      this.deleteExistingData(42);
    } else if (type.trim().indexOf('Bulky Articles') !== -1) {
      this.bulkyArticlesDisplay = false;
      this.processAccArray('bulkyArticles');
      this.deleteExistingData(43);
    } else if (type.trim().indexOf('Export Import Charge') !== -1) {
      this.exportImportChargeDisplay = false;
      this.processAccArray('bulkyArticles');
      this.deleteExistingData(44);
    } else if (type.trim().indexOf('Pickup Delivery Holiday') !== -1) {
      this.pickupDeliveryHolDisplay = false;
      this.processAccArray('pickupDeliveryHol');
      this.deleteExistingData(45);
    } else if (type.trim().indexOf('Carrier Supervisor Personnel') !== -1) {
      this.carrierSuperPersonnelDisplay = false;
      this.processAccArray('carrierSuperPersonnel');
      this.deleteExistingData(50);
    } else if (type.trim().indexOf('Warehouse Pickup Delivery') !== -1) {
      this.warehousePickUpDeliveryHolDisplay = false;
      this.processAccArray('warehousePickUpDelivery');
      this.deleteExistingData(51);
    } else if (type.trim().indexOf('Other Hhg') !== -1) {
      this.otherHhgAccServicesDisplay = false;
      this.processAccArray('otherHhgAccServices');
      this.deleteExistingData(52);
    } else if (type.trim().indexOf('Extra Pickup Delivery') !== -1) {
      this.extraPickUpDeliveryDisplay = false;
      this.processAccArray('extraPickUpDelivery');
      this.deleteExistingData(38);
    }
  }

  /**
   * @description Accessorial array deletion process
   * @param frmCtlName
   */
  processAccArray(frmCtlName) {
    this.accessorialArray.forEach((element, index) => {
      const accObj = element;
      if (accObj['controlName'] === frmCtlName) {
        this.accessorialArray.splice(index, 1);
      }
    });

  }

  /**
   * @description To set Shipper authorize value
   */
  setShipAuth(formGrp, formCtl, formTspCtrl) {
    const formGrpCtl = this.hhgShipmentAccessorialForm.get(formGrp);
    const ctlVal = formGrpCtl.get(formCtl).value;
    if (ctlVal === '' || ctlVal === null) {
      formGrpCtl.get(formCtl).setValue('Authorized');
    }
    if (formGrpCtl.get(formTspCtrl).value ===  '' || formGrpCtl.get(formTspCtrl).value ===  null) {
      formGrpCtl.get(formTspCtrl).setValue(null);
    }
    if (this.hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').valid) {
      const excessValue = ((this.hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').value - this.accessorialInfo.releasedValuationCost) * 0.85) / 100;
      this.excessCostValTransport = excessValue > 1 ? excessValue : 0;
      this.totalCostExcessValuation = this.excessCostValTransport + this.excessCostValStorage;
      if (this.storageTransitDisplay && (AppConstants.isNotNullCondition(this.hhgShipmentAccessorialForm.get('storageInTransit.originNoDays').value)  || AppConstants.isNotNullCondition(this.hhgShipmentAccessorialForm.get('storageInTransit.destNoDays').value))) {
        this.calculateExcessCostValStorage();
      }
    }
  }

  /**
   * @description caluculates storage in transit cost value
   */
  calculateExcessCostValStorage() {
    if (AppConstants.isNotNullCondition(this.hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').value)) {
      const excessValueStorage = ((this.hhgShipmentAccessorialForm.get('excessValuation').get('reqTotalValuation').value - this.accessorialInfo.releasedValuationCost) * 0.18) / 100;
      this.excessCostValStorage = parseFloat(excessValueStorage.toFixed(2));
      this.totalCostExcessValuation = this.excessCostValTransport + this.excessCostValStorage;
    }
  }

  /**
   * @description TSP acceptance value is set
   * @param formGrp
   * @param formCtl
   */
  setTspAcceptance(formGrp, ctlName) {
    const ctlVal = this.accessorialInfo[ctlName];
    if (ctlVal === '') {
      this.hhgShipmentAccessorialForm.get(formGrp).get(ctlName).setValue(null);
    }
  }

   /**
   * @description To update validators for SIT Origin & Destination depending on the chosen SIT
   * @param eventObj
   */
  changeSitInfo(eventObj) {
    const originSitFg = this.hhgShipmentAccessorialForm.get('storageInTransit') as UntypedFormGroup;
    if (eventObj.target.id === 'sit-origin') {
      // Origin
      if (eventObj.target.checked) {
        originSitFg.get('originNoDays').setValidators([Validators.required]);
      } else {
        originSitFg.get('originNoDays').clearValidators();
      }

    } else {
      if (eventObj.target.checked) {
        originSitFg.get('destNoDays').setValidators([Validators.required]);
      } else {
        originSitFg.get('destNoDays').clearValidators();
      }

    }
  }
  onSitChange() {
    const originSitFg = this.hhgShipmentAccessorialForm.get('storageInTransit') as UntypedFormGroup;
    if (originSitFg.get('destNoDays') !== null || originSitFg.get('originNoDays') !== null) {
      this.calculateExcessCostValStorage();
    }
  }

  /**
   * @description Modal for adding messages
   */
  openAdditionalInfo(accCode, accId) {
    for (let i = 0; i < this.existingAccessorials.length; i++) {
      if (this.existingAccessorials[i].hhGAccessorialsId == accId) {
        accId = this.existingAccessorials[i].bookAccessorialsId;
      }
    }

    this.hhgShipmentAccessorialAdditionalInfoService.getMessagesByAccessorialsId(accId).subscribe(existing => {
      if (existing != null) {
        this.existingMessages = [];
        for (let i = 0; i < existing.length; i++) {
          this.existingMessages.push(existing[i].message);
        }
      }
      const initialState = {
        redirectedFromBol: this.redirectedFromBol
      };
      this.bsModalRef = this.modalService.show(HhgShipmentAccessorialAdditionalinfoComponent, { initialState });
      this.bsModalRef.content.action.subscribe((message) => {
        this.messageArray.push(message);
        this.existingMessages.push(message.message);
      });
      for(let aMessage of this.messageArray){
        if(aMessage.bookAccessorialsId === accId){
          this.existingMessages.push(aMessage.message);
        }
      }
      this.bsModalRef.content.title = accCode;
      this.bsModalRef.content.shipmentsId = this.shipmentsId;
      this.bsModalRef.content.accId = accId;
      this.bsModalRef.content.messageHistoryArray = this.existingMessages;
      
    }, (error) => {
    }, () => {
    });



  }

  findAuditObject(checkVal, auditTrailArr) {
    const result = auditTrailArr.find(obj => {
      if (obj.fieldName == checkVal) {
        return obj;
      }
    });
    return result;
  }
  /**
   * @description saves accessorial info to back-end
   */
  saveAccessorial() {
    this.loader.show();
    this.bookShipArray = [];
    this.auditTrailArray = [];
    if (this.exclusiveUseOfVehiclesDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 36) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 36)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles').value['eovShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles').value['eovTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles').value['eovShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles').value['eovTspAuthorize'];
        this.hhg.hhGAccessorialsId = 36;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('eovShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'eovShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.extraPickUpDeliveryDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 38) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 38)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('extraPickUpDelivery').value['extraPickDelShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('extraPickUpDelivery').value['extraPickDelTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('extraPickUpDelivery').value['extraPickDelShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('extraPickUpDelivery').value['extraPickDelTspAuthorize'];
        this.hhg.hhGAccessorialsId = 38;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('extraPickDelShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'extraPickDelShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.expeditedServiceDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 37) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 37)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('expeditedService').value['exServShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('expeditedService').value['exServTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('expeditedService').value['exServShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('expeditedService').value['exServTspAuthorize'];
        this.hhg.hhGAccessorialsId = 37;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('exServShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'exServShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.travelTimeDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 39) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 39)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('travelTime').value['ttShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('travelTime').value['ttTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('travelTime').value['ttShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('travelTime').value['ttTspAuthorize'];
        this.hhg.hhGAccessorialsId = 39;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('ttShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'ttShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.debrisRemovalDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 40) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 40)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('debrisRemoval').value['drShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('debrisRemoval').value['drTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('debrisRemoval').value['drShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('debrisRemoval').value['drTspAuthorize'];
        this.hhg.hhGAccessorialsId = 40;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('drShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'ttShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.extraLaborDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 41) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 41)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('extraLabor').value['extLaborShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('extraLabor').value['extLaborTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('extraLabor').value['extLaborShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('extraLabor').value['extLaborTspAuthorize'];
        this.hhg.hhGAccessorialsId = 41;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('extLaborShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'extLaborShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.shuttleServiceDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 42) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 42)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('shuttleService').value['sServiceShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('shuttleService').value['sServiceTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('shuttleService').value['sServiceShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('shuttleService').value['sServiceTspAuthorize'];
        this.hhg.hhGAccessorialsId = 42;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('sServiceShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'sServiceShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.bulkyArticlesDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 43) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 43)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('bulkyArticles').value['baShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('bulkyArticles').value['baTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('bulkyArticles').value['baShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('bulkyArticles').value['baTspAuthorize'];
        this.hhg.hhGAccessorialsId = 43;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('baShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'baShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.exportImportChargeDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 44) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 44)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('exportImportCharge').value['eiChargeShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('exportImportCharge').value['eiChargeTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('exportImportCharge').value['eiChargeShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('exportImportCharge').value['eiChargeTspAuthorize'];
        this.hhg.hhGAccessorialsId = 44;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('eiChargeShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'eiChargeShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.pickupDeliveryHolDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 45) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 45)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('pickupDeliveryHol').value['pdHolShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('pickupDeliveryHol').value['pdHolTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('pickupDeliveryHol').value['pdHolShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('pickupDeliveryHol').value['pdHolTspAuthorize'];
        this.hhg.hhGAccessorialsId = 45;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('pdHolShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'pdHolShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.carrierSuperPersonnelDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 50) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 50)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel').value['csPersonnelShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel').value['csPersonnelTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel').value['csPersonnelShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel').value['csPersonnelTspAuthorize'];
        this.hhg.hhGAccessorialsId = 50;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('csPersonnelShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'csPersonnelShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.warehousePickUpDeliveryHolDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 51) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 51)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery').value['whPickDelShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery').value['whPickDelTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery').value['whPickDelShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery').value['whPickDelTspAuthorize'];
        this.hhg.hhGAccessorialsId = 51;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('whPickDelShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'whPickDelShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.otherHhgAccServicesDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 52) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 52)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('otherHhgAccServices').value['otherHhgAccSerShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('otherHhgAccServices').value['otherHhgAccSerTspAuthorize'];
      } else {
        this.hhg = new HhgBookShipAccessorials();
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('otherHhgAccServices').value['otherHhgAccSerShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('otherHhgAccServices').value['otherHhgAccSerTspAuthorize'];
        this.hhg.hhGAccessorialsId = 52;
        this.hhg.shipmentsId = this.shipmentsId;
      }
      this.adt = this.findAuditObject('otherHhgAccSerShipAuthorize', this.existingAuditTrail);
      if (this.adt == null) {
        this.adt = new AuditTrail();
        this.adt.fieldName = 'otherHhgAccSerShipAuthorize';
        this.adt.newValue = this.hhg.shipperRequest;
      } else {
        this.adt.oldValue = this.adt.newValue;
        this.adt.newValue = this.hhg.shipperRequest;
      }
      this.auditTrailArray.push(this.adt);
      this.bookShipArray.push(this.hhg);
      this.hhg = null;
      this.adt = null;
    }
    if (this.excessValuationDisplay === true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 47) != -1){
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 47)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('excessValuation').value['excessValuationShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('excessValuation').value['excessValuationTspAuthorize'];
        this.hhg.requestedTotalVal = this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'];
        this.hhg.hhGAccessorialsId = 47;
        this.hhg.shipmentsId = this.shipmentsId;
        this.hhg.accessorialCost = this.excessCostValTransport;
        this.bookShipArray.push(this.hhg);
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 48)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('excessValuation').value['excessValuationShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('excessValuation').value['excessValuationTspAuthorize'];
        this.hhg.requestedTotalVal = this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'];
        this.hhg.hhGAccessorialsId = 48;
        this.hhg.shipmentsId = this.shipmentsId;
        this.hhg.accessorialCost = this.excessCostValStorage;
        this.bookShipArray.push(this.hhg);
      }
      else {
        for (let i = 47; i < 49; i++) {
          this.hhg = new HhgBookShipAccessorials();
          this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('excessValuation').value['excessValuationShipAuthorize'];
          this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('excessValuation').value['excessValuationTspAuthorize'];
          this.hhg.requestedTotalVal = this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'];
          this.hhg.hhGAccessorialsId = i;
          this.hhg.shipmentsId = this.shipmentsId;
          this.hhg.accessorialCost = i === 47 ? this.excessCostValTransport : i === 48 ? this.excessCostValStorage : 0;
          this.bookShipArray.push(this.hhg);
      }
    }
  }
    if (this.storageTransitDisplay == true) {
      if (this.checkExistingAccessorials(this.existingAccessorials, 46) != -1) {
        this.hhg = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 46)];
        this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originShipAuthorize'];
        this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originTspAuthorize'];
        this.hhg.sitNumberOfDays = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originNoDays'];
        this.hhg.requestedTotalVal = this.excessValuationDisplay === true ? this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'] : null;
        this.hhg.accessorialCost = (parseFloat(this.accessorialInfo.originsitMilesCost) + parseFloat(this.accessorialInfo.originStorageCost)).toFixed(2);
      } else if ((this.hhgShipmentAccessorialForm.get('storageInTransit').value['originNoDays'] !== null) &&
                (this.hhgShipmentAccessorialForm.get('storageInTransit').value['originNoDays'] !== ""))
        //if (this.hhgShipmentAccessorialForm.get('storageInTransit').value['originCb'] == true) {
           {
            this.hhg = new HhgBookShipAccessorials();
            this.hhg.shipperRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originShipAuthorize'];
            this.hhg.tspRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originTspAuthorize'];
            this.hhg.sitNumberOfDays = this.hhgShipmentAccessorialForm.get('storageInTransit').value['originNoDays'];
            this.hhg.requestedTotalVal = this.excessValuationDisplay === true ? this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'] : null;
            this.hhg.accessorialCost = (parseFloat(this.accessorialInfo.originsitMilesCost) + parseFloat(this.accessorialInfo.originStorageCost)).toFixed(2);
            this.hhg.usageType = 'Origin';
            this.hhg.hhGAccessorialsId = 46;
            this.hhg.shipmentsId = this.shipmentsId;
          }
      if (this.checkExistingAccessorials(this.existingAccessorials, 49) != -1) {
        this.hhg2 = this.existingAccessorials[this.checkExistingAccessorials(this.existingAccessorials, 49)];
        this.hhg2.shipperRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destShipAuthorize'];
        this.hhg2.tspRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destTspAuthorize'];
        this.hhg2.sitNumberOfDays = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destNoDays'];
        this.hhg2.requestedTotalVal = this.excessValuationDisplay === true ? this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'] : null;
        this.hhg2.accessorialCost = (parseFloat(this.accessorialInfo.destsitMilesCost) + parseFloat(this.accessorialInfo.destStorageCost)).toFixed(2);
      } else if ((this.hhgShipmentAccessorialForm.get('storageInTransit').value['destNoDays'] !== null) &&
                 (this.hhgShipmentAccessorialForm.get('storageInTransit').value['destNoDays'] !== "")){
        //if (this.hhgShipmentAccessorialForm.get('storageInTransit').value['destCb'] == true) {
          this.hhg2 = new HhgBookShipAccessorials();
          this.hhg2.shipperRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destShipAuthorize'];
          this.hhg2.tspRequest = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destTspAuthorize'];
          this.hhg2.sitNumberOfDays = this.hhgShipmentAccessorialForm.get('storageInTransit').value['destNoDays'];
          this.hhg2.requestedTotalVal = this.excessValuationDisplay === true ? this.hhgShipmentAccessorialForm.get('excessValuation').value['reqTotalValuation'] : null;
          this.hhg2.accessorialCost = (parseFloat(this.accessorialInfo.destsitMilesCost) + parseFloat(this.accessorialInfo.destStorageCost)).toFixed(2);
          this.hhg2.usageType = 'Destination';
          this.hhg2.hhGAccessorialsId = 49;
          this.hhg2.shipmentsId = this.shipmentsId;
        //}
      }
      if (this.hhg != null) {
        this.bookShipArray.push(this.hhg);
      }
      if (this.hhg2 != null) {
        this.bookShipArray.push(this.hhg2);
      }
    }

    this.loader.show();
    this.hhgBookShipAccessorialsService.saveOrUpdateHhgAccessorials(this.bookShipArray).subscribe(shipArray => {
      this.bookShipArray = shipArray;
      this.addMessages(this.bookShipArray, this.messageArray);
    }, (error) => {
      this.alertService.error('There was an error saving the accessorials');
      this.saveSuccess = false;
      this.loader.hide();
    }, () => {
      this.saveSuccess = true;
      this.existingAccessorials = this.bookShipArray;
      if (this.messageArray != null && this.messageArray.length > 0) { // Save Acc Messages
        this.hhgShipmentAccessorialAdditionalInfoService.saveOrUpdateAccessorialMessages(this.messageArray).subscribe(response => {
          this.additionalMessageResponse = response;
          this.messageArray.length = 0;
        }, (error) => {
          this.saveSuccess = false;
        }, () => {
          this.saveSuccess = true;
        });
      }

      this.alertService.success('Successfully saved accessorials');
      window.scrollTo(0, 0);
      this.loader.hide();
      this.retrieveSuccess = false;
      this.router.navigate(['/hhgbookshipment'], {
        queryParams:
          {bookshipmentid: this.bookShipmentId}
      });
    });




    // } else if (eventObj.target.value.indexOf('Saturday') !== -1 && !this.pickupDeliveryHolDisplay) {
    // 	this.pickupDeliveryHolDisplay = true;
    // 	let accObj = {};
    // 	accObj['controlName'] = 'pickupDeliveryHol';
    // 	accObj['saCtl'] = 'pdHolShipAuthorize';
    // 	accObj['tspStl'] = 'pdHolTspAcceptance';
    // 	this.accessorialArray.push(accObj);
    // 	this.setShipAuth('pickupDeliveryHol', 'pdHolShipAuthorize');
    // 	if(this.exclusiveUseOfVehiclesDisplay = true) {

    //
  }
  auditShipmentIds(audArr) {
    const tempArray = [];
    for (let i = 0; i < audArr.length; i++) {
      audArr[i].shipmentsId = this.shipmentsId;
      if (audArr[i].oldValue == audArr[i].newValue) {
        tempArray.push(i);
      }
    }
    for (let n = 0; n < tempArray.length; n++) {
      audArr.splice(n, 1);
    }
  }
  checkExistingAccessorials(accessorialArray, accessorialCode) {
    for (let i = 0; i < accessorialArray.length; i++) {
      if (accessorialArray[i].hhGAccessorialsId == accessorialCode) {
        return i;
      }
    }
    return -1;

  }

  addMessages(accArray, msgArray) {
    for (let i = 0; i < accArray.length; i++) {
      for (let j = 0; j < msgArray.length; j++) {
        if (msgArray[j].bookAccessorialsId == accArray[i].hhGAccessorialsId) {
          msgArray[j].bookAccessorialsId = accArray[i].bookAccessorialsId;
        }
      }
    }
  }
  /**
   * @description Open modal for adding extra pickup delivery information
   */
  openExtraPickupDeliveryAddress() {
    const initialState = {
      shipmentsId: this.shipmentsId,
      redirectedFromBol: this.redirectedFromBol
    };
    this.bsModalRef = this.modalService.show(HhgExtraPickupdeliveryAddressComponent, { initialState, class: 'modal-lg' });
  }
  /**
   * @description Loading existing data for carrier
   */
  loadExistingData() {
    for (let i = 0; i < this.existingAccessorials.length; i++) {
      this.currentExisting = this.existingAccessorials[i];
      if (this.currentExisting.hhGAccessorialsId === 36) {
        this.exclusiveUseOfVehiclesDisplay = true;
        this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles.eovShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('exclusiveUseOfVehicles.eovTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.eovTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 37) {
        this.expeditedServiceDisplay = true;
        this.hhgShipmentAccessorialForm.get('expeditedService.exServShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('expeditedService.exServTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.exServTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 39) {
        this.travelTimeDisplay = true;
        this.hhgShipmentAccessorialForm.get('travelTime.ttShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('travelTime.ttTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.ttTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 40) {
        this.debrisRemovalDisplay = true;
        this.hhgShipmentAccessorialForm.get('debrisRemoval.drShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('debrisRemoval.drTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.drTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 41) {
        this.extraLaborDisplay = true;
        this.hhgShipmentAccessorialForm.get('extraLabor.extLaborShipAuthorize').setValue(this.currentExisting.shipperRequest);
      this.hhgShipmentAccessorialForm.get('extraLabor.extLaborTspAuthorize').setValue(this.currentExisting.tspRequest);

        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.extLaborTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 42) {
        this.shuttleServiceDisplay = true;
        this.hhgShipmentAccessorialForm.get('shuttleService.sServiceShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('shuttleService.sServiceTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.sServiceTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 43) {
        this.bulkyArticlesDisplay = true;
        this.hhgShipmentAccessorialForm.get('bulkyArticles.baShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('bulkyArticles.baTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.baTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 44) {
        this.exportImportChargeDisplay = true;
        this.hhgShipmentAccessorialForm.get('exportImportCharge.eiChargeShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('exportImportCharge.eiChargeTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.eiChargeTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 45) {
        this.pickupDeliveryHolDisplay = true;
        this.hhgShipmentAccessorialForm.get('pickupDeliveryHol.pdHolShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('pickupDeliveryHol.pdHolTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.pdHolTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 46 || this.currentExisting.hhGAccessorialsId === 49) {
        this.storageTransitDisplay = true;
        if (this.currentExisting.usageType == 'Origin') {
          this.hhgShipmentAccessorialForm.get('storageInTransit.originCb').setValue(true);
          this.hhgShipmentAccessorialForm.get('storageInTransit.originShipAuthorize').setValue(this.currentExisting.shipperRequest);
          this.hhgShipmentAccessorialForm.get('storageInTransit.originTspAuthorize').setValue(this.currentExisting.tspRequest);
          this.hhgShipmentAccessorialForm.get('storageInTransit.originNoDays').setValue(Number(this.currentExisting.sitNumberOfDays));
          if (this.currentExisting.tspRequest != null) {
            this.accessorialInfo.originTspAcceptance = this.currentExisting.tspRequest;
          }
          this.savedOriginCost = this.currentExisting.accessorialCost;
        }
        if (this.currentExisting.usageType === 'Destination') {
          this.hhgShipmentAccessorialForm.get('storageInTransit.destCb').setValue(true);
          this.hhgShipmentAccessorialForm.get('storageInTransit.destShipAuthorize').setValue(this.currentExisting.shipperRequest);
          this.hhgShipmentAccessorialForm.get('storageInTransit.destTspAuthorize').setValue(this.currentExisting.tspRequest);
          // this.hhgShipmentAccessorialForm.get('storageInTransit.destNoDays').setValue(this.currentExisting.sitNumberOfDays);
          this.hhgShipmentAccessorialForm.get('storageInTransit.destNoDays').setValue(Number(this.currentExisting.sitNumberOfDays));
          if (this.currentExisting.tspRequest != null) {
            this.accessorialInfo.destTspAcceptance = this.currentExisting.tspRequest;
          }
           this.savedDestCost = this.currentExisting.accessorialCost;
        }
        if (this.routedFrom === 'bol') {
        this.accessorialInfo.totalSitCharge = this.savedOriginCost + this.savedDestCost;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 47 || this.currentExisting.hhGAccessorialsId === 48) {
        this.excessValuationDisplay = true;
        this.hhgShipmentAccessorialForm.get('excessValuation.excessValuationShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('excessValuation.excessValuationTspAuthorize').setValue(this.currentExisting.tspRequest);
        this.hhgShipmentAccessorialForm.get('excessValuation.reqTotalValuation').setValue(this.currentExisting.requestedTotalVal);
        if (this.currentExisting.hhGAccessorialsId === 47) {
          this.excessCostValTransport = this.currentExisting.accessorialCost || 0;
        }
        if (this.currentExisting.hhGAccessorialsId === 48) {
          this.excessCostValStorage = this.currentExisting.accessorialCost || 0;
        }
        this.totalCostExcessValuation = this.excessCostValTransport + this.excessCostValStorage;
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.excessValTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 50) {
        this.carrierSuperPersonnelDisplay = true;
        this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel.csPersonnelShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('carrierSuperPersonnel.csPersonnelTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.csPersonnelTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 51) {
        this.warehousePickUpDeliveryHolDisplay = true;
        this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery.whPickDelShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('warehousePickUpDelivery.whPickDelTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.whPickDelTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 52) {
        this.otherHhgAccServicesDisplay = true;
        this.hhgShipmentAccessorialForm.get('otherHhgAccServices.otherHhgAccSerShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('otherHhgAccServices.otherHhgAccSerTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest != null) {
          this.accessorialInfo.otherHhgAccSerTspAcceptance = this.currentExisting.tspRequest;
        }
      }
      if (this.currentExisting.hhGAccessorialsId === 38) {
        this.extraPickUpDeliveryDisplay = true;
        this.hhgShipmentAccessorialForm.get('extraPickUpDelivery.extraPickDelShipAuthorize').setValue(this.currentExisting.shipperRequest);
        this.hhgShipmentAccessorialForm.get('extraPickUpDelivery.extraPickDelTspAuthorize').setValue(this.currentExisting.tspRequest);
        if (this.currentExisting.tspRequest !== null) {
          this.accessorialInfo.extraPickDelTspAcceptance = this.currentExisting.tspRequest;
        }
      }

    }
  }

  deleteExistingData(hhgId) {
    let index = 0;
    for (let i = 0; i < this.existingAccessorials.length; i++) {
      if (this.existingAccessorials[i].hhGAccessorialsId === hhgId) {
        index = this.existingAccessorials[i].bookAccessorialsId;
        this.hhgBookShipAccessorialsService.deleteBybookAccessorialsId(index).subscribe(response => {
          this.additionalMessageResponse = response;
        }, (error) => {
        }, () => {

        });

      }
    }
    this.retrieveSuccess = false;
  }

  goBack() {
    // this.location.back();
    this.router.navigate(['/hhgbookshipment'], {
      queryParams:
        {bookshipmentid: this.bookShipmentId}
    });
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
